import { serviceMaker, methods, api } from "@/http/index.js";

export const getfeemaster = (id) =>
    serviceMaker(`/feemaster/${id}`, methods.GET, api.NGB);
export const getListFeemaster = () =>
    serviceMaker(`/feemaster`, methods.GET, api.NGB);
export const getFeemasterTemplate = () =>
    serviceMaker(`/feemaster/template`, methods.GET, api.NGB);
export const createFeemaster = (data) =>
    serviceMaker(`/feemaster`, methods.POST, api.NGB, data);
export const deletefeemaster = (id) =>
    serviceMaker(`/feemaster/${id}`, methods.DELETE, api.NGB);
export const editfeemaster = (id, data) =>
    serviceMaker(`/feemaster/${id}`, methods.PUT, api.NGB, data);
